import React, { useState } from 'react';
import { enviarToken } from '../api'; // <-- tus funciones API
import Banner from "../components/Banner";

const RecuperarPWD = () => {
  const [telefono, setTelefono] = useState('');
  const [id, setID] = useState('');
  const [respuesta, setRespuesta] = useState('');
  const [mostrarModal, setMostrarModal] = useState(false);

  const handleCloseModal = () => {
    setMostrarModal(false);
    setRespuesta('');
    setTelefono('');
    setID('');
  };

  const handleEnviarToken = async () => {
    try {
      const data = new FormData();
      data.append('telefono', telefono);
      data.append('id', id);
      const res = await enviarToken(data);

      if (res.data) {
        setRespuesta(res.data);
        setMostrarModal(true);
      } else {
        setRespuesta('Respuesta desconocida del servidor.');
      }
    } catch (err) {
      console.log(err.message || 'Error en la solicitud.');
    }
  };

  return (
      <div className="container">
        <Banner />
        <h2 className="text-xl font-bold mb-4">Recuperar Contraseña</h2>
        <center><a href="/">Regresar</a></center><br/><br/>
          <div className="input-group">
          <label className='label'>Telefono:</label>
          <input
            type="text"
            placeholder="Teléfono"
            value={telefono}
            onChange={(e) => {
              const input = e.target.value;
              // Solo permite números y hasta 10 caracteres
              if (/^\d{0,10}$/.test(input)) {
                setTelefono(input);
              }
            }}
            className="input"
          /></div>
          <div className="input-group">
          <label className='label'>Número Halcon:</label>
          <input
          type="text"
          placeholder="Numero Halcon"
          value={id}
          onChange={(e) => {
            const input = e.target.value;
            // Solo permite números y hasta 10 caracteres
            if (/^\d{0,3}$/.test(input)) {
              setID(input);
            }
          }}
          className="input"
        /><br/></div>
          <center><h5>**Ambos campos son obligatorios y sin espacios</h5>
          <h5>(ejemplo "4771234567")</h5></center>
          <button onClick={handleEnviarToken} className="button">
            Solicitar Nueva Contraseña
          </button>
          {mostrarModal && (
            <div className="modal-overlay2" onClick={handleCloseModal}>
              <div className="modal-historia-content" onClick={(e) => e.stopPropagation()}>
                <button className="close-btn" onClick={handleCloseModal}>
                  ✖
                </button>
                <h3 className="modal-title">Resultado</h3>
                <p className="modal-message">{respuesta}</p>
              </div>
            </div>
          )}

          </div>

          
  
  );
};

export default RecuperarPWD;
